import api from './api';

const BASE_URL = '/support/feedback';

const feedbackService = {
  createFeedback: async (feedbackData) => {
    try {
      const response = await api.post(`${BASE_URL}/create`, feedbackData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default feedbackService; 